import styled, { keyframes, css } from 'styled-components';

import Color from '../../styles/color';
import LoadingColorBarSvg from '../../assets/images/color-bar-loading.svg';
import ColorBarSvg from '../../assets/images/color-bar.svg';

type ColorBarProps = {
  $loading: boolean;
};

export const Container = styled.div`
  width: 100%;
  height: 60px;
`;

export const Content = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 60px;
  background-color: ${Color.primary};
  align-items: center;
  box-sizing: border-box;
  padding: 0 16px;
`;

export const Logo = styled.img`
  height: 21px;
  margin-top: 8px;
`;

const movebar = keyframes`
  from {
    background-position: 0 0;
  }
  to {
    background-position: ${window.innerWidth}px 0;
  }
`;

export const ColorBar = styled.div<ColorBarProps>`
  position: relative;
  width: 100%;
  height: 4px;
  ${({ $loading }) =>
    $loading
      ? css`
          background-image: url(${LoadingColorBarSvg});
          background-position: 0 0;
          background-repeat: repeat-x;
          animation: ${movebar} 1s linear infinite;
        `
      : css`
          background-image: url(${ColorBarSvg});
        `}
`;
